import type { VideoModelConfig } from '../../types';

/** Hailuo 2.3（无尾帧，field_map.tail_image.max=0） */
export const hailuo2_3: VideoModelConfig = {
  id: '01KER137SJWPNYC3Y8HTK46G1A',
  displayName: 'Hailuo 2.3',
  defaults: {
    resolution: '768P',
    duration: 5,
  },
  resolutionOptions: [
    { label: '768P', value: '768P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'options', options: [5, 10] },
  capabilities: {
    tailFrame: false,
  },
  limits: {
    maxRefImages: 1,
  },
};
